<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">求人票 返却内容反映</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <div class="dialog__body">

    <!-- 企業からの相談内容表示（表示のみ・編集不可） -->
    <div class="consulting-info" *ngIf="job.dynamicData.jobCompanyAzCheckIsRaConsulting === 1">
      <h3 class="consulting-info__title">企業からの相談内容</h3>
      <ag-job-az-check-consulting-info
        [consultingInfo]="companyConsultingInfo"
      ></ag-job-az-check-consulting-info>
    </div>

    <!-- 修正内容反映 -->
    <div class="compare-header">
      <span>現在の求人票内容</span>
      <span>企業の修正内容</span>
    </div>

    <ng-container *ngIf="compareSections.length === 0">
      <div class="section-title">企業からの求人票返却情報はすべて反映済みです。</div>
    </ng-container>
    <ng-container *ngIf="compareSections.length > 0">
      <ng-container *ngFor="let section of compareSections">
        <div class="section-title">{{ section.title }}</div>
        <div class="compare-body">
          <div class="compare-row" *ngFor="let row of section.rows">
            <div class="compare-row__col compare-row__col--left">
              <div class="row-title">{{ row.label }}</div>
              <div class="row-value">
                <ng-container
                  *ngTemplateOutlet="rowValue; context: { row: row, valueRaw: row.currentValueRaw }"
                ></ng-container>
              </div>
            </div>
            <div class="compare-row__col compare-row__col--button">
              <button
                class="apply-button"
                [disabled]="isRowApplied(row)"
                (click)="applyCompanyValue(row)"
              >
                反映
              </button>
            </div>
            <div class="compare-row__col compare-row__col--right overview-row">
              <div class="overview-row__label">{{ row.label }}</div>
              <div class="overview-row__value">{{ row.companyValue }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #rowValue let-row="row" let-valueRaw="valueRaw">
    <ng-container [ngSwitch]="row.inputType">
      <div class="row-value__options" *ngSwitchCase="'checkbox'">
        <label class="row-value__option" *ngFor="let option of row.options">
          <input
            type="checkbox"
            [checked]="isOptionSelected(valueRaw, option)"
            (change)="toggleOption(row, option)"
          />
          {{ optionLabel(option) }}
        </label>
      </div>
      <div class="row-value__options" *ngSwitchCase="'radio'">
        <label class="row-value__option" *ngFor="let option of row.options">
          <input
            type="radio"
            [name]="row.fieldKey"
            [checked]="isOptionSelected(valueRaw, option)"
            (change)="selectOptionValue(row, optionValue(option))"
          />
          {{ optionLabel(option) }}
        </label>
      </div>
      <ag-dynamic-form
        class="row-value__form"
        *ngSwitchCase="'form'"
        [metadata]="row.formMeta"
        [model]="editingModel"
        (changed)="onSalaryTableFormChanged($event)"
      ></ag-dynamic-form>
      <select class="row-value__input" *ngSwitchCase="'dropdown'" [ngModel]="valueRaw" [ngModelOptions]="{ standalone: true }" (ngModelChange)="selectOptionValue(row, $event)">
        <option *ngFor="let option of row.options" [value]="optionValue(option)">{{ optionLabel(option) }}</option>
      </select>
      <textarea
        class="row-value__input"
        *ngSwitchDefault
        [ngModel]="row.currentValue"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onFreeTextChanged(row, $event)"
      ></textarea>
    </ng-container>
  </ng-template>

  <div class="dialog__footer">
    <button class="dialog__button dialog__button--gray" (click)="close()">
      キャンセル
    </button>
    <button class="dialog__button dialog__button--blue" [disabled]="isUpdating" (click)="update()">
      更新
    </button>
  </div>
</div>
